import React, { FC, useState } from 'react'

import { RangeDateDropdownBase, RangeCalendarWithSwitches } from 'src/components/molecules'
import { CalendarPopoverContainer } from 'src/components/molecules/dataDisplays/CalendarPopoverContainer'

import { useShowRangeCalendar } from 'src/hooks'

type Props = {
  startDate?: Date
  endDate?: Date
  onClickDay: (input: { startDate: Date; endDate?: Date }) => void
  className?: string
}

export const RangeDateDropdown: FC<Props> = ({ startDate, endDate, onClickDay, className }) => {
  const [isShowCalendar, setIsShowCalendar] = useState(false)
  const { updateShowRangeCalendar } = useShowRangeCalendar()

  const handleOnClickDropdown = () => {
    setIsShowCalendar(!isShowCalendar)
    updateShowRangeCalendar(!isShowCalendar)
  }

  return (
    <CalendarPopoverContainer
      calendar={
        <RangeCalendarWithSwitches
          startDate={startDate}
          endDate={endDate}
          onClickDay={onClickDay}
        />
      }
      isShowCalendar={isShowCalendar}
      className={className}
    >
      <RangeDateDropdownBase
        startDate={startDate}
        endDate={endDate}
        onClick={handleOnClickDropdown}
      />
    </CalendarPopoverContainer>
  )
}
